/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_Stats_Top_DrInputs */

const en_directory_external_directories_stats_top_dr = /** @type {(inputs: Directory_External_Directories_Stats_Top_DrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highest DR`)
};

const zh_directory_external_directories_stats_top_dr = /** @type {(inputs: Directory_External_Directories_Stats_Top_DrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最高 DR`)
};

/**
* | output |
* | --- |
* | "Highest DR" |
*
* @param {Directory_External_Directories_Stats_Top_DrInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_stats_top_dr = /** @type {((inputs?: Directory_External_Directories_Stats_Top_DrInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_Stats_Top_DrInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_stats_top_dr(inputs)
	return zh_directory_external_directories_stats_top_dr(inputs)
});
export { directory_external_directories_stats_top_dr as "directory.external_directories.stats_top_dr" }